import { Injectable } from '@angular/core';

import { DbPcvizService } from '@mirage-projects/cw-pcviz-core';

@Injectable({ providedIn: 'root' })
export class FilesHelperService {
    constructor(private dbPcvizService: DbPcvizService) {}

    /**
     * Returns the extension of a given file
     * @param file File where to get its extension
     */
    getExtension(file: File | string): string {
        let fileName = '';

        fileName = file instanceof File ? file.name : file;

        return fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    }

    /**
     * Returns the name of a file without its extension
     * @param file File where to get its name
     */
    getFileNameWithoutExtension(file: File): string {
        const fileName = file.name;
        return fileName.substring(0, fileName.lastIndexOf('.'));
    }

    cleanUpFileNameCharacters(fileName: string): string {
        return this.dbPcvizService.getUtils().cleanUpFileNameCharacters(fileName);
    }

    async getImgUrlBase64FromFile(file: File): Promise<string> {
        const arrayBuffer = await file.arrayBuffer();
        const base64String = this.arrayBufferToBase64(arrayBuffer);
        const mimeType = file.type;
        const imageUrl = `data:${mimeType};base64,${base64String}`;
        return imageUrl;
    }

    private arrayBufferToBase64(buffer: ArrayBuffer): string {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
}
